import { useState } from 'react';
import { signOut } from '../../sign-out/domain/use-cases/signOut';
import { useLoyaltyAccountStore } from '../../../account/domain/stores/useLoyaltyAccountStore';
import { PassengersPageId } from '../../../app/pages/domain/constants/PageId';
import { useUrlForPageId } from '../../../app/pages/ui/utils/useUrlForPageId';
import { useNavigate } from '../../../shared/router/useNavigate';

export const useDeleteAccount = () => {
	const navigate = useNavigate();
	const store = useLoyaltyAccountStore();
	const [isLoading, setIsLoading] = useState(store.isLoading);
	const redirectUrl = useUrlForPageId(PassengersPageId.Home);

	const redirect = async () => {
		if (!redirectUrl) return;

		await navigate(redirectUrl);
	};

	const onDeleteAccount = async () => {
		try {
			setIsLoading(true);
			await store.deleteAccount();
			await signOut({ redirect });
		} finally {
			setIsLoading(false);
		}
	};

	return {
		store,
		isLoading,
		error: store.error,
		onDeleteAccount,
	};
};
